import React from 'react'
import HOCButton from 'web/components/Button';
import TextInput from 'web/components/form-elements/TextInput';
import { Form, Formik} from 'formik';
import { SelectWrapper } from '../DashBoard/dashBoardStyled';
import Select from 'react-select';
import * as Yup from 'yup';

export default function EditAdminModal(props) {
    const options = [
        { label: "All", value: "7" },
        { label: "Dashboard", value: "8" },
        { label: "User Management", value: "5" },
        { label: "User Activity", value: "9" },
        { label: "Reports", value: "6" },
        { label: "Posts", value: "17" },
        { label: "Resolution Center", value: "10" },
        { label: "Subscription", value: "11" },
        { label: "Content Moderatrion", value: "12" },
        { label: "Promo Code", value: "13" },
        { label: "Referral Code", value: "14" },
        { label: "Application Non Users", value: "15" },
        { label: "Language Localization", value: "16" },
        { label: "Location Management", value: "18" },
        { label: "New Invitations", value: "19" },
        { label: "Post Visibility", value: "20" },
        { label: "Retry Orders", value: "21" },
        { label: "Cancel Orders", value: "22" },
        { label: "Quotes", value: "23" },
        { label: "Terms and Conditions", value: "24" },
        { label: "Chat", value: "25" },
        { label: "PT Plus Admin", value: "26" },
        { label: "Order Chat", value: "27" },
    ];
    const submitAdminAcess = data => {
        props.onEnter(data.values)
    }

    const editEmail = localStorage.getItem('EditAdminEmail')
    const roles = localStorage.getItem('EditAdminRoles')
    let adminRoles = []
    adminRoles = roles.split(',').map(val => {
        if (val === 'SUPER_ADMIN') return { label: "All", value: "7" }
        if (val === 'DASHBOARD_ADMIN') return { ...adminRoles, label: "Dashboard", value: "8" }
        if (val === 'USER_MANAGEMENT') return { ...adminRoles, label: "User Management", value: "5" }
        if (val === 'USERACTIVITY_ADMIN') return { ...adminRoles, label: "User Activity", value: "9" }
        if (val === 'USER_REPORTS') return { ...adminRoles, label: "Reports", value: "6" }
        if (val === 'RESOLUTION_CENTER_ADMIN') return { ...adminRoles, label: "Resolution Center", value: "10" }
        if (val === 'SUBSCRIPTION_ADMIN') return { ...adminRoles, label: "Subscription", value: "11" }
        if (val === 'CONTENT_MODERATION_ADMIN') return { ...adminRoles, label: "Content Moderatrion", value: "12" }
        if (val === 'PROMO_CODE') return { ...adminRoles, label: "Promo Code", value: "13" }
        if (val === 'REFERRAL_CODE') return { ...adminRoles, label: "Referral Code", value: "14" }
        if (val === 'APPLICATION_NON_USERS') return { ...adminRoles, label: "Application Non Users", value: "15" }
        if (val === 'LANGUAGE_LOCALIZATION') return { ...adminRoles, label: "Language Localization", value: "16" }
        if (val === 'POSTS') return { ...adminRoles, label: "Posts", value: "17" }
        if (val === 'LOCATION_MANAGEMENT') return { ...adminRoles, label: "Location Management", value: "18" }
        if (val === 'NEW_INVITATIONS') return { ...adminRoles, label: "New Invitations", value: "19" }
        if (val === 'POST_VISIBILITY') return { ...adminRoles, label: "Post Visibility", value: "20" }
        if (val === 'RETRY_ORDERS') return { ...adminRoles, label: "Retry Orders", value: "21" }
        if (val === 'CANCEL_ORDERS') return { ...adminRoles, label: "Cancel Orders", value: "22" }
        if (val === 'QUOTES') return { ...adminRoles, label: "Quotes", value: "23" }
        if (val === 'TERMS_AND_CONDITIONS') return { ...adminRoles, label: "Terms and Conditions", value: "24" }
        if (val === 'CHAT') return { ...adminRoles, label: "Chat", value: "25" }
        if (val === 'PT_PLUS') return { ...adminRoles, label: "PT Plus Admin", value: "26" }
        if (val === 'ORDER_CHAT') return { ...adminRoles, label: "Order Chat", value: "27" }
    })

    const INITIAL_VALUES_EDIT_ADMIN = {
        email: editEmail,
        access: adminRoles
    };

    const VALIDATION_SCHEMA_EDIT_ADMIN = Yup.object().shape({
        access: Yup.array()
            .min(1, 'Pick at least 1 role')
            .of(
                Yup.object().shape({
                    label: Yup.string().required(),
                    value: Yup.string().required(),
                })
            )
    });
    return (
        <div>
            <Formik
                initialValues={INITIAL_VALUES_EDIT_ADMIN}
                validationSchema={VALIDATION_SCHEMA_EDIT_ADMIN}
                onSubmit={(values) => {
                }}>
                {(props) => {
                    const { isValid, dirty, values, errors, touched, handleChange, setFieldValue } = props;
                    return (
                        <>
                            <Form>
                                <p className="mt-0">Email</p>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ width: '100%' }}>
                                        <TextInput
                                            name='email'
                                            showErrorMessages={true}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                                <p className="mt-0">Select Access</p>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ width: '100%' }}>
                                        <SelectWrapper>
                                            <Select
                                                name='access'
                                                value={values.access}
                                                isMulti
                                                options={options}
                                                onChange={value => {
                                                    if (value !== null) {
                                                        let temp = value.map(data => data.label)
                                                        if (temp.includes('All')) setFieldValue('access', [{ label: "All", value: "7" }])
                                                        else setFieldValue('access', value)
                                                    } else {
                                                        setFieldValue('access', [])
                                                    }
                                                }}
                                            />
                                        </SelectWrapper>
                                    </div>
                                </div>
                                <div style={{ marginTop: '15px', textAlign: '-webkit-center' }}>
                                    <HOCButton
                                        type='app-green-button submitBtn'
                                        handleClick={() => {
                                            submitAdminAcess(props)
                                        }}
                                        disabled={!(isValid && dirty)}>
                                        Edit Admin Roles
                                    </HOCButton>
                                </div>
                            </Form>
                        </>
                    );
                }}
            </Formik>
        </div>
    )
}